// TotalInventoryShortage Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get totalInventoryShortageList from backend then update totalInventoryShortageList in vuex store ***** //
export const updateTotalInventoryShortageList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('product_shortage_index', { params: params })
    commit('updateTotalInventoryShortageList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch TotalInventoryShortage from backend ***** //
export const fetchTotalInventoryShortageCount = async ({ commit }) => {
  try {
    const result = await Axios.get('product_shortage_count')
    commit('fetchTotalInventoryShortageCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get reportInventoryShortageList from backend then update reportInventoryShortageList in vuex store ***** //
export const updateReportInventoryShortageList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_quantity_alarm/${payload.outlet_id}`, { params: params })
    commit('updateTotalInventoryShortageList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch reportInventoryShortage from backend ***** //
export const fetchReportInventoryShortageCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_quantity_alarm_count/${payload}`)
    commit('fetchTotalInventoryShortageCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
